import { color } from "@smartsheet/design-tokens-react";
import { themed, ThemeMode } from "@smartsheet/sds-theme-internal";

const defaultColor = "blue";

export const backgroundColorThemes = themed({
    berry: color("color--background--spectrum-pink--default"),
    berryLight: color("color--background--spectrum-pink--weak"),
    blue: color("color--background--spectrum-blue--default"),
    blueLight: color("color--background--spectrum-blue--weak"),
    green: color("color--background--spectrum-green--default"),
    greenLight: color("color--background--spectrum-green--weak"),
    orange: color("color--background--spectrum-orange--default"),
    orangeLight: color("color--background--spectrum-orange--weak"),
    purple: color("color--background--spectrum-violet--default"),
    purpleLight: color("color--background--spectrum-violet--weak"),
    red: color("color--background--spectrum-red--default"),
    redLight: color("color--background--spectrum-red--weak"),
    teal: color("color--background--spectrum-teal--default"),
    tealLight: color("color--background--spectrum-teal--weak"),
    yellow: color("color--background--spectrum-yellow--default"),
    yellowLight: color("color--background--spectrum-yellow--weak"),

    success: color("color--background--spectrum-mint--weak"),
    warning: color("color--border--warning--default"),
    error: color("color--background--destructive--weak"),
    info: color("color--background--neutral--default"),
});

export const backgroundColor = (color: keyof typeof backgroundColorThemes, themeMode: ThemeMode): string => {
    const theme = backgroundColorThemes[color] || backgroundColorThemes[defaultColor];
    return theme(themeMode);
};
